export var CashTransactionActionEnum;
(function (CashTransactionActionEnum) {
    CashTransactionActionEnum["DEPOSIT"] = "DEPOSIT";
    CashTransactionActionEnum["WITHDRAW"] = "WITHDRAW";
})(CashTransactionActionEnum || (CashTransactionActionEnum = {}));
//# sourceMappingURL=cash-transaction-action.enum.js.map